import { render } from "./GetStarted.vue?vue&type=template&id=5cd1b26c"
import script from "./GetStarted.vue?vue&type=script&lang=js"
export * from "./GetStarted.vue?vue&type=script&lang=js"
script.render = render

export default script